module.exports = { 
  CHOOSE_OUTLET : "Please select anyone outlet",
  CHOOSE_POSTALCODE : "Please enter a valid postal code",
  UNIT_NUMBER_ERROR : "Please enter Floor No/Unit No"
   
 }